export function getReadableType(type: string, defaultCardTypeKey: string = 'museum') {
    const cardTypeKeyMatcher = /^.+?([A-Z][a-z]+)/
    const cardTypeMatchResult = type.match(cardTypeKeyMatcher)
    const typeId =
        cardTypeMatchResult && cardTypeMatchResult.length > 1
            ? cardTypeMatchResult[1].toLowerCase()
            : defaultCardTypeKey
    return `entity.itemTypes.${typeId}`
}